<template>
  <div class="page-activity" :style="{ 'background-color': gallery.backgroundColor }" :data-cms="gallery._moduleId">
    <div v-if="loading" class="loading">
      <a-spin size="large"></a-spin>
    </div>
    <div v-else class="activity-wrap ">
      <div class="activity-container ">
        <div class="banner">
          <img :src="gallery.banner.image" alt="banner" />
        </div>
        <div class="activity-content-wrapper"
          :style="{ background: `url(${gallery.backgroundImage.image}) center 0/100% 100% no-repeat` }">
          <div class="module module-f">
            <div class="cell-body">

            </div>
          </div>
          <div v-for="(floor, floorIndex) in gallery.floors" :class="[`module module-${floorIndex}`, {'disabled': floor.disabled}]" :key="floorIndex"
            :id="floor.id">
            <div class="cell-body"
              :style="{ 'background': `url(${floor.floor?.image}) center  no-repeat`, 'height': `${floor.floor?.height}px` }">

              <div v-if="floorIndex === 0" class="flights-list">
                <div class="flights-list-title">
                  <span style="width: 15%">起飞</span>
                  <span style="width: 15%">落地</span>
                  <span style="width: 40%">航班日期</span>
                  <span style="width: 30%">销售日期</span>
                </div>
                <div class="flights-list-body">
                  <table class="flights-list-table">
                    <tr v-for="(ticket, tIndex) in route.discountTicketList" :key="tIndex">
                      <td width="15%">{{ ticket.depName }}</td>
                      <td width="15%">{{ ticket.arrName }}</td>
                      <td width="40%">{{ ticket.flightDateRange }}</td>
                      <!-- <td>{{ ticket.flightDateRange[0] }}-{{ ticket.flightDateRange[1] }}</td> -->
                      <td width="30%">
                        <!-- <span>{{ ticket.saleDateRange[0] }}-{{ ticket.saleDateRange[1] }}</span> -->
                        <span>{{ ticket.saleDateRange }}</span>
                        <span class="book" @click="goToFlightSearch(ticket)">立即预定</span>
                      </td>
                    </tr>
                  </table>
                </div>
              </div>

              <div v-if="floorIndex === 1" class="real_name_gift"
                :style="`left:${giftLeft}px;top:${giftTop}px;height:${giftHei}px;width:${giftWid}px`"
                @click="getRealNameGift()"></div>

              <div v-if="floorIndex === 2">
                <div v-for="( recommend, reIndex ) in route?.recommendedRouteList" :key="recommend.depCode"
                  class="recommend-block"
                  :style="`left:${recommend.coordinate?.split(',')[0]}px;top:${recommend.coordinate?.split(',')[1]}px`">
                  <div v-for="(  flight, fIndex  ) in recommend?.list" class="recommend-item" :key="fIndex"
                    :style="{ top: getBtnTop(reIndex, fIndex) + 'px', height: extendConfig.routeButtonHeight }" @click="goToFlightSearch(flight)">
                  </div>
                </div>
              </div>

              <div v-if="floorIndex === 3" class="recommend-list">
                <div v-for="( product, pIndex ) in  products " class="recommend-product" :key="pIndex"
                  @click="onRecommendProduct(product)">
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import './index'
import imgLazy from '@/directives/imgLazy.js'
import moment from 'moment'
import { axios } from '@/utils/axios'
import { debounce } from 'lodash'
const mainSettings = window.__MICRO_ROOT__ ?? {}
export default {
  data () {
    return {
      loading: true,
      gallery: {},
      route: {},
      couponDateRange: [],
      products: [],
      activity: {},
      giftLoading: false,
      isShowModal: false,
      giftWid: 0,
      giftHei: 0,
      giftLeft: 0,
      giftTop: 0,
      couponEnable: true,
      extendConfig: {}
    }
  },

  directives: {
    imgLazy: imgLazy
  },

  created () {
    this.getCmsData()
  },

  methods: {
    async getCmsData () {
      try {
        await mainSettings?.cms?.getPageData().then(res => {
          console.log('res >>>', res)
          this.couponEnable = res.config?.couponEnable
          this.extendConfig = res.config?.extendConfig ?? {}
          this.gallery = res?.['membership-day-gallary'] || {}
          this.route = res?.['membership-day-route'] || {}
          const dayDate = res?.['membership-day-date'] || {}
          this.couponDateRange = dayDate['activityDate'] ?? []
          this.products = res?.['membership-day-product']?.['list'] ?? []
          const { coordinateEnd, coordinateStart } = dayDate
          const startX = coordinateStart?.split(',')[0] || 0
          const startY = coordinateStart?.split(',')[1] || 0
          const endX = coordinateEnd?.split(',')[0] || 0
          const endY = coordinateEnd?.split(',')[1] || 0
          this.$nextTick(() => {
            this.loading = false
            this.giftLeft = startX
            this.giftTop = startY
            this.giftHei = endY
            this.giftWid = endX
          })
          // 兼容部分模块未配置的情况
          const { couponDateRange, products, gallery = {} } = this
          if (couponDateRange.length === 0) {
            gallery.floors?.splice(1, 0, { disabled: true })
          }
          if (products?.length === 0) {
            gallery.floors?.splice(3, 0, { disabled: true })
          }
        })
      } catch (err) {
        console.log('err >>>> ', err)
      }
    },

    getBtnTop (pIndex, index) {
      const { extendConfig } = this
      const mol = index
      const normalTop = extendConfig.routeFirstLinePaddingTop ?? 33
      const top = extendConfig.routeLineSpacing ?? 65
      return normalTop + Math.floor(mol / 2) * top
    },

    getRealNameGift: debounce(async function () {
      const { couponDateRange = [], couponEnable = true } = this
      if (!couponEnable) {
        this.$message.warn('暂不支持领券。')
        return
      }
      try {
        const result = await axios({
          url: '/api/activityCoupon/receiveConpon',
          method: 'post',
          data: {
            'beginTime': moment(couponDateRange[0]).format('YYYY-MM-DD'),
            'endTime': moment(couponDateRange[1]).format('YYYY-MM-DD')
          }
        })
        this.$message.success(result)
      } catch (error) {
        if (error?.code === '-1') {
          this.onConfirm(error.data)
          return
        }
        this.$message.error(error.message)
      }
    }, 500),

    goToFlightSearch (item) {
      const { route } = this
      // 特惠航线日期偏移量
      const dateOffset = route.dateOffset || 1
      const time = moment(new Date()).add(dateOffset, 'days').format('YYYY-MM-DD')
      let routeData = this.$router.resolve({
        query: { type: 'ONEWAY',
          isInternational: false,
          ADT: '1',
          depCode: item.depCode,
          arrCode: item.arrCode,
          depType: 'airport',
          arrType: 'airport',
          depDate: time },
        path: '/flight/search'
      })
      window.open(routeData.href, '_blank')
    },

    onRecommendProduct (product) {
      this.$router.push({ path: product.url })
    },

    onConfirm (message) {
      this.$confirm({
        content: message,
        okText: '去认证',
        cancelText: '取消',
        onOk: () => {
          mainSettings.router.push({
            pathname: '/micro/user/authenticate',
            query: { type: 'auth' }
          })
        },
        onCancel: () => {
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.page-activity {
  min-height: 300px;
  width: 100%;
  overflow: hidden;

  .anchor {
    position: absolute;
  }

  .loading {
    padding: 200px 0;
    text-align: center;
  }

  .activity-wrap {
    position: relative;
    min-width: 1058px;

    .activity-container {
      .banner {
        width: 100%;
        position: relative;

        img {
          display: block;
          width: 100%;
        }
      }

      .activity-content-wrapper {
        position: relative;
        width: 100%;

        .module {
          margin: 0 auto;
          position: relative;
          width: 1058px;
          z-index: 14;

          &.disabled {
            display: none;
          }

          &.module-0 {
            .cell-body {
              .flights-list {
                margin: 0px auto;
                width: 913px;
                padding-top: 211px;

                .flights-list-title {
                  line-height: 56px;
                  color: #fff;
                  background-color: #157dc0;
                  padding-right: 20px;

                  span {
                    display: inline-block;
                    font-size: 20px;
                    font-weight: 700;
                    text-align: center;

                    &:last-child {
                      width: 40%;
                    }
                  }
                }

                .flights-list-body {
                  height: 475px;
                  overflow-y: auto;
                  margin-top: 3px;
                  background-color: #2f94fb;
                  color: #fff;

                  .flights-list-table {
                    width: 100%;

                    tr {
                      cursor: pointer;
                      text-shadow: 1px 1px #000;
                    }

                    td {
                      line-height: 56px;
                      font-size: 18px;
                      font-weight: 700;
                      text-align: center;

                      .book {
                        height: 35px;
                        border-radius: 18px;
                        border: 1px solid #fff;
                        padding: 0 10px;
                        color: #fff;
                        font-weight: 300;
                        text-shadow: none;
                      }

                      &:last-child {
                        width: 40%;

                        span {
                          margin-right: 15px;
                        }

                      }
                    }
                  }
                }
              }
            }

          }

          &.module-1 {
            .cell-body {
              position: relative;
              height: 1020px;

              .real_name_gift {
                position: absolute;
                width: 195px;
                height: 56px;
                top: 416px;
                left: 127px;
                display: inline-block;
                position: absolute;
                cursor: pointer;
                // background-color: rgba(255, 0, 255, 0.3);
              }
            }
          }

          &.module-2 {
            .cell-body {
              position: relative;
              height: 3125px;

              .recommend-block {
                width: 828px;
                height: 126px;
                position: absolute;
                top: 715px;
                left: 110px;
                // background-color: rgba(255, 0, 255, 0.3);

                .recommend-item {
                  position: absolute;
                  top: 5px;
                  cursor: pointer;
                  width: 130px;
                  height: 38px;
                  // background-color: rgba(255, 255, 1, 0.3);

                  &:nth-child(odd) {
                    left: 282px;
                  }

                  &:nth-child(even) {
                    right: 5px;
                  }
                }

              }

            }
          }

          &.module-3 {
            .cell-body {
              position: relative;
              height: 1020px;

              .recommend-list {
                position: absolute;
                width: 873px;
                top: 244px;
                left: 97px;
                display: inline-block;
                position: absolute;
                cursor: pointer;
                // background-color: rgba(255, 0, 255, 0.3);

                .recommend-product {
                  width: 100%;
                  height: 277px;
                  // background-color: rgba(255, 255, 1, 0.3);
                  margin-bottom: 20px;
                }
              }
            }
          }
        }
      }
    }
  }

}

.real_name_load1 {
  position: fixed;
  left: 0px;
  right: 0px;
  top: 0px;
  bottom: 0px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: rgba(255, 255, 255, 0.5);
}
</style>
